module.exports = __webpack_public_path__ + "assets/img/platform.b8b28d96.png";